module.exports = __webpack_public_path__ + "static/media/plus.cd7d44a0.svg";